<template>
  <div class="customer-activation-container simple-search-table-container default-table">
    <div class="head flex-align-center">
      <div>
        <select-customer-mine :value.sync="queryParams.customer_id" size="mini" style="width: 200px"/>
        <el-select v-model="queryParams.activation_type" placeholder="激活类型选择" size="mini" clearable
                   style="width: 170px">
          <el-option v-for="item in MapType" :key="item.value" :value="item.value" :label="item.label"/>
        </el-select>
        <select-team :value.sync="queryParams.organization_id" size="mini" style="width: 170px"/>
        <el-button type="primary" size="mini" @click="handelSearch">查询</el-button>
      </div>
      <div class="flex-align-center">
        <el-button icon="el-icon-refresh" type="text" circle :disabled="doLoading" :loading="doLoading"
                   @click="handleRunScript" style="padding:0;margin-right: 4px;"/>
        <span class="tip-time"
              v-if="tableData[(tableData.length-1)]">更新时间：{{ tableData[(tableData.length - 1)].updated_at }}</span>
        <span v-else class="tip-time">暂无数据</span>
        <month-select-group ref="date" @selected="handelSearch"/>
      </div>
    </div>

    <ape-table ref="apeTable" :data="tableData" :loading="loading" :paging-data="configPage"
               highlight-current-row border is-full-height
               @switchPaging="getTableData" @changeTableSort="changeTableSort">
      <el-table-column prop="customer_name" label="客户" header-align="center" align="center" min-width="160"
                       show-overflow-tooltip sortable="custom">
        <template slot-scope="{row:{customer_name,is_error,date_before_activation,date_activation}}">
          <el-tooltip v-if="is_error" effect="dark" placement="right">
            <span slot="content">激活前最后一次成交日期：{{
                date_before_activation|parseTime
              }} 与激活日期：{{ date_activation|parseTime }} 区间间隔小于90天</span>
            <div v-if="is_error" class="flag-error">异常</div>
          </el-tooltip>
          {{ customer_name }}
        </template>
      </el-table-column>
      <el-table-column prop="activation_order_type" label="订单类型" header-align="center" align="center"
                       min-width="120" sortable="custom">
        <template slot-scope="{row:{activation_order_type}}">
          <template v-if="MapOrderType[activation_order_type]">
            <span
                :style="`color:${MapOrderType[activation_order_type].color}`">{{
                MapOrderType[activation_order_type].label
              }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="payment_account" label="订单金额" header-align="center" align="right" min-width="120"
                       sortable="custom">
        <template slot-scope="{row:{payment_account}}">
          {{ payment_account|numberFormat }}
        </template>
      </el-table-column>
      <el-table-column prop="activation_type" label="激活类型" header-align="center" align="center" min-width="120"
                       sortable="custom">
        <template slot-scope="{row:{activation_type}}">
          <template v-if="MapType[activation_type]">
            <span :style="`color:${MapType[activation_type].color}`">{{ MapType[activation_type].label }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="date_before_activation" label="激活前最后一次成交日期" header-align="center" align="center"
                       min-width="120"
                       sortable="custom">
        <template slot-scope="{row:{date_before_activation}}">
          {{ date_before_activation|parseTime }}
        </template>
      </el-table-column>
      <el-table-column prop="date_activation" label="激活日期" header-align="center" align="center" min-width="120"
                       sortable="custom">
        <template slot-scope="{row:{date_activation}}">
          {{ date_activation|parseTime }}
        </template>
      </el-table-column>
      <el-table-column prop="sale" label="销售" header-align="center" align="center" min-width="120" sortable="custom"/>
      <el-table-column prop="organization_name" label="销售小组" header-align="center" align="center" min-width="120"
                       sortable="custom"/>
      <el-table-column v-if="userAuth.can_delete_customer_activation" label="操作" header-align="center" align="center"
                       min-width="80">
        <template slot-scope="{row:{id,is_error}}">
          <el-popconfirm v-if="is_error" title="确认移除吗？" @confirm="confirmRemoveRow(id)">
            <span slot="reference" class="span-btn">移除</span>
          </el-popconfirm>
        </template>
      </el-table-column>
    </ape-table>
    <div class="tip-help">
      老客激活，系统计算生成（条件）：<br>
      1.公司老客激活：曾经和公司其他销售有成交(排除自己)，近3个月(90天)及以上和公司无合作（不区分销售人员），（公司再次）自己成交订单；<br>
      2.小组老客激活：自己曾经有成交，近6个月(180天)及以上和公司无合作（不区分销售人员），（公司再次）自己成交订单；<br>
      3.订单筛选，数据默排除“冲账订单”，“已撤单”；<br>
    </div>
  </div>
</template>

<script>
import SelectCustomerMine from "@/components/Selects/customer.vue";
import SelectTeam from "@/components/Selects/team.vue";
import {
  deleteCustomerActivation,
  getCustomerActivationPage,
  runCustomerActivationScript
} from "@/api/customerActivation";
import ApeTable from "@/components/ApeTable.vue";


const MapType = {
  1: {label: '小组老客激活', value: 1, color: 'rgb(255, 119, 77)'},
  2: {label: '公司老客激活', value: 2, color: 'rgb(254, 76, 127)'},
}

const MapOrderType = {
  1: {label: '普通订单', value: 1, color: 'rgb(255, 119, 77)'},
  2: {label: '全案营销', value: 2, color: 'rgb(254, 76, 127)'},
}
const ConfigPage = {
  is_show: true,
  layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 30,
  page: 1,
}
export default {
  name: "index",
  components: {SelectTeam, SelectCustomerMine, ApeTable},
  data() {
    return {
      MapType,
      MapOrderType,
      configPage: ConfigPage,
      loading: false,
      doLoading: false,
      queryParams: {
        order_by: null,
        customer_id: null,
        activation_type: null,
        organization_id: null
      },
      mapCombineIdCount: {},
      tableData: []
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    handelSearch() {
      this.getTableData(true)
    },
    getParams(isSearch) {
      let pageInfo = this.$refs['apeTable'].getPagingInfo()
      const params = {...this.queryParams, ...pageInfo}
      params.page = isSearch ? 1 : pageInfo.current_page

      const {year, month} = this.$refs.date.searchCondition
      params.year = year || null
      params.month = month || null
      return params
    },
    async getTableData(isSearch = false) {
      if (!this.$refs.date) {
        return;
      }
      this.loading = true
      const response = await getCustomerActivationPage(this.getParams(isSearch))
      this.loading = false
      this.tableData = response.model.data || []
      this.configPage.total = response.model.total || 0

      this.tableData.map(_ => {
        _.row_color = _.is_error ? 'red' : ''
      })
    },
    changeTableSort(_) {
      const {prop, order} = _
      let order_by = null
      if (order) {
        order_by = order === 'ascending' ? `\`${prop}\` asc` : `\`${prop}\` desc`
      }
      this.queryParams.order_by = order_by
      this.getTableData()
    },
    async handleRunScript() {
      //执行权限更新
      this.doLoading = true
      await runCustomerActivationScript(this.$refs.date.searchCondition)
      this.msgSuccess('老客激活统计初始化任务已发布，请稍后点击查询是否更新')

      setTimeout(() => {
        this.doLoading = false
      }, 500)
    },
    async confirmRemoveRow(id) {
      const response = await deleteCustomerActivation({id})
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      await this.getTableData()
    }
  }
}
</script>

<style lang="scss">
.customer-activation-container {
  padding: 24px;

  .el-table .red-row {
    background: #ffeeee;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }
}
</style>
